const MAX_TRUSTED_FORM_RETRIES = 10;
const TRUSTED_FORM_RETRY_DELAY_MS = 600;

export const getTrustedFormCertificateUrl = (
    attempt = 1,
): Promise<string | null> => {
    return new Promise((resolve) => {
        const trustedFormHiddenElement = document.getElementById(
            "TrustedFormCertUrl_0",
        ) as HTMLInputElement | null;

        if (trustedFormHiddenElement && trustedFormHiddenElement.value) {
            resolve(trustedFormHiddenElement.value);
        } else if (attempt <= MAX_TRUSTED_FORM_RETRIES) {
            setTimeout(() => {
                resolve(getTrustedFormCertificateUrl(attempt + 1));
            }, TRUSTED_FORM_RETRY_DELAY_MS);
        } else {
            resolve(null);
        }
    });
};
